<template>
    <v-dialog :value="showDialog" persistent>
        <v-card>
            <v-card-title class="pa-5">
                <span class="headline warning--text">Debug Console - {{ terminalId }}</span>
                <v-spacer></v-spacer>
                <v-tooltip bottom z-index="999" color="black" open-delay="200">
                    <template v-slot:activator="{ on }">
                <v-btn v-on="on" color="warning" icon @click="$emit('close')">
                    <v-icon large>mdi-window-minimize</v-icon>
                </v-btn>
                </template>
                <span ><pre >Minimize</pre></span>
            </v-tooltip>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-row>
                    <v-col cols="6">
                        <v-data-table :headers="headers" :items="axioRequestResponse" sort-by="time"
                            @clic:row="onRowClicked" :sort-desc="[true]" style="cursor: pointer">
                            <template v-slot:item="{ item }">
                                <v-tooltip bottom z-index="999" color="black" open-delay="200">
                <template v-slot:activator="{ on }">
                                <tr v-on="on" @click="onRowClicked(item)">
                                    <td> {{ formatDate(item.time) }}</td>
                                    <td> <v-icon v-if="item.type === 'Response'" color="warning">mdi-download</v-icon>
                                        <v-icon v-if="item.type === 'Request'" color="success">mdi-upload</v-icon>
                                        {{ item.type }}
                                    </td>
                                    <td> {{ getUrl(item) }}</td>
                                    <td> {{ getMethod(item) }}</td>
                                    <td> <v-chip v-if="item.status" small label
                                            :color="item.status === 200 ? 'success' : 'error'">
                                            {{ item.status }}
                                        </v-chip>
                                        <div v-else>-</div>
                                    </td>
                                </tr>
                                </template>
                                <span ><pre class="tooltipTextRaceNavigationPreformatted">Click to view data</pre></span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-col>
                    <v-col cols="6">

                        <div class="pa-4" style="border: 1px dashed #eee; overflow: scroll;height: 100%;width: 100%;">
                            <h4>
                                Data:
                            </h4>

                            <pre>{{ tryParseJson(details) }}</pre>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapState } from 'vuex';
import { format } from 'date-fns';
export default {
    name: 'DebugConsole',
    props: {
        showDialog: Boolean,
    },
    data() {
        return {
            headers: [
                { text: 'Date Time', value: 'time' },
                { text: 'Type', value: 'type', sortable: false },
                { text: 'URL', value: 'url', sortable: false },
                { text: 'Method', value: 'method', sortable: false },
                { text: 'Status', value: 'status', sortable: false, align: 'center' }
            ],
            details: ''
        }
    },
    methods: {
        formatDate(dateTime) {
            return format(dateTime, 'yyyy-MM-dd HH:mm:ss:SSS')
        },
        getUrl(item) {
            return item.url?.substring(item.url.lastIndexOf('/')) || item.config?.url?.substring(item.config?.url.lastIndexOf('/'))
        },
        getMethod(item) {
            return item.method?.toUpperCase() || item.config?.method?.toUpperCase()
        },
        onRowClicked(item) {
            this.details = JSON.stringify(item?.data, null, 2)
        },
        tryParseJson(str) {
            try {
                return JSON.stringify(JSON.parse(str), null, 2)
            }
            catch (e) {
                return str
            }
        }
    },
    computed: {
        ...mapState(['axioRequestResponse', 'terminalId']),
    },

}
</script>
<style></style>
